export const getCloneTaskId = (state) => state.cloneProfile.taskId;
export const getCloneTargetMac = (state) => state.cloneProfile.targetMac;
export const getCloneProgress = (state) => state.cloneProfile.progress;
